import { render, staticRenderFns } from "./person-inline.vue?vue&type=template&id=718599a7"
import script from "./person-inline.vue?vue&type=script&lang=js"
export * from "./person-inline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports